<template>
  <div>
    <px-view-header title="Compras" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-compra-header :on-click-refresh="onClickRefresh"
                              :on-change-filter="onChangeFilter"
                              @change="onChangeFilter"/>
      <lista-compra :compras="compras"
                    :loading="loading"
                    :on-change-options="onChangeOptions"
                    :options-list="optionsList"
                    @remove="onRemove"
                    @remove-rascunho="onRemoveRascunho"
                    @update="onClickRefresh"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-compra/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import ListaCompra from './ListaCompra.vue';
import ListagemCompraHeader from './ListagemCompraHeader.vue';
import CompraService from '../compra-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      compras: {
        content: [],
        total: 0,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Compras' },
      ],
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCompra', ['stringFilter', 'listOptions']),
    ...mapGetters('user', ['user']),
    ...mapGetters('entidade', ['idEntidade']),
  },
  methods: {
    ...mapActions('listagemCompra', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onChangeFilter() {
      this.updateFilter(this.stringFilter);
      this.resetPage();
      this.getCompras();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getCompras();
    },
    onClickRefresh() {
      this.getCompras();
    },
    onRemove(item) {
      this.loading = true;
      CompraService.remover(item.id)
        .then(() => {
          this.$toast('Compra removida com sucesso', { color: 'success' });
          this.getCompras();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRemoveRascunho(item) {
      this.loading = true;
      CompraService.removerRascunho(item.id)
        .then(() => {
          this.$toast('Rascunho excluido com sucesso', { color: 'success' });
          this.getCompras();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.resetPagination();
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCompras() {
      this.loading = true;

      const { limit, offset } = this.listOptions;
      return CompraService.getCompras({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.compras = response.data;
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  components: {
    ListaCompra,
    ListagemCompraHeader,
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
